export const PASSWORD_MODE = {
  PASSWORD: "password",
  TEXT: "text",
}

export const PASSWORD_TOOLTIP = {
  PASSWORD: "Hide Password",
  TEXT: "Show Password",
}
